import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { disabledBlockSx } from "../disabledStyles";
import XVideoWithText from "./XVideoWithText";

const VideoOptions = ({ setState, state, field, isDisabled = false }: any) => {
  const [items, setItems] = useState<any>(
    state[field?.name] ? state[field?.name] : [{ id: "1", option: "", video: "" }],
  );

  useEffect(() => {
    setState({ ...state, [field?.name]: items });
  }, [items]);

  const updateVideo = (videoObj, currentItem) => {
    const updatedItem = items.map((cItem) =>
      cItem.id === currentItem ? { ...cItem, video: videoObj } : cItem,
    );
    setItems(updatedItem);
  };
  return (
    <Box sx={disabledBlockSx(isDisabled)}>
      <XVideoWithText callBack={updateVideo} items={items} setItems={setItems} />
    </Box>
  );
};
export default VideoOptions;
